<template>
  <LayoutBasic>
    <template v-slot:title>
      <v-list-item @click="$router.push('/')" class="hoverable">
        <v-list-item-icon>
          <v-icon large>mdi-view-dashboard</v-icon>
          <!-- ícono tipo "módulos" -->
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="title font-weight-bold"
            >Inicio</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>

    <template v-slot:navigation-title>Productos</template>
    <template v-slot:vista-previa>
      <transition name="fade-slide" mode="out-in">
        <router-view />
      </transition>
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";

export default {
  name: "ProductoEmpresaRegistrarLayout",
  components: { LayoutBasic },
};
</script>
<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s ease;
}
.fade-slide-enter {
  opacity: 0;
  transform: translateY(20px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>


  